import React, { Component } from "react";
import { Flex } from "reflexbox";
import styled from "styled-components";
import axios from "axios";
import Markdown from "../components/Markdown";
import colors from "../config/colors";

const CenteredFlex = styled(Flex)`
    align-items: center;
    flex-direction: column;
    width: 100%;
`;

const ContentContainer = styled(Flex)`
    padding: 3em 0em;
    max-width: 70em;
`;

const HeaderImage = styled(Flex)`
    background-color: ${colors.Blue};

    justify-content: center;
    align-items: center;
    width: 100%;

    background-position: center;
    background-image: url(/assets/imgs/MobilePageHeader.svg);
    background-repeat: no-repeat;
    background-size: cover;

    height: 60vw;

    @media only screen and (min-width: 641px) {
        
        height: 28vw;
        background-image: url(/assets/imgs/TabletPageHeader.svg);
    }

    @media only screen and (min-width: 832px) {
        
        height: 290px;
        background-image: url(/assets/imgs/DesktopPageHeader.svg);
        background-size: auto;
    }  
`;

const Title = styled(Flex)`
    color: white;
    font-weight: bold;
`;


interface TermsConditionsIProps {

}

interface TermsConditionsIState {
    termsConditions: string;
}

export default class TermsConditions extends Component<TermsConditionsIProps, TermsConditionsIState> {
    state: TermsConditionsIState = {
        termsConditions: "",
    }

    componentDidMount() {
        const url = '/assets/texts/terms_conditions.md';
        axios.get(url).then(result => this.setState({ termsConditions: result.data }));
    }

    render() {
        const { termsConditions } = this.state;

        return <CenteredFlex>
            <HeaderImage>
                <Title fontSize={['2em', '3em', '4em']} >Terms and<br />Conditions</Title>
            </HeaderImage>
            <ContentContainer width={[0.9, 0.8, 0.7]} flexDirection={"column"}>
                <Markdown content={termsConditions} />
            </ContentContainer>
        </CenteredFlex>
    }

}
